import type { ILoginLocale } from '@/Pages/Onboard/Login/Locale/Login.locale';

const ptBR: ILoginLocale = {
  title: 'Faça login na {brand}',
  email: {
    label: 'Email',
    placeholder: 'exemplo@email.com',
    error: 'Por favor insira um endereço de email válido',
  },
  password: {
    label: 'Senha',
    placeholder: 'Sua senha',
    error: 'Senha é obrigatória',
  },
  passcode: {
    label: 'Código de autenticação',
    placeholder: '000000',
  },
  twoFactor: {
    title: 'Autenticação em dois fatores',
    subtitle: 'Digite o código de 6 dígitos do seu app autenticador para {email}.',
  },
  button: {
    login: 'Entrar',
    forgotPassword: 'Esqueceu a senha?',
    verify: 'Verificar',
    back: 'Voltar',
  },
  terms: {
    message1: 'Ao fazer login, você concorda com',
    message2: ' a nossa ',
    terms: 'Termos de Serviço',
    privacy: 'Política de Privacidade',
  },
  errors: {
    invalidCredentials: 'Email ou senha inválidos. Por favor, tente novamente.',
    accountLocked: 'Sua conta foi bloqueada. Por favor, entre em contato com o suporte.',
    accountDisabled: 'Sua conta foi desativada. Por favor, entre em contato com o suporte.',
    networkError: 'Erro de rede. Por favor, verifique sua conexão e tente novamente.',
    twoFactorRequired: 'Autenticação de dois fatores obrigatória.',
    requiredPasscode: 'Digite seu código de 6 dígitos da autenticação de dois fatores.',
    invalidPasscode: 'Código de autenticação inválido. Tente novamente.',
    blockedPassword: 'Conta temporariamente bloqueada. Redefina sua senha.',
    blockedTwoFactor: 'Muitas tentativas inválidas. Tente novamente em {time}.',
    blockedTwoFactorToast: 'Muitas tentativas inválidas. Tente novamente em alguns minutos.',
    twoFactorBootstrapMissingToken: 'Token de configuração de 2FA ausente. Faça login novamente.',
  },
  cookieConsent: {
    necessary: 'Cookies Estritamente Necessários',
    analytics: 'Cookies de Análise',
    necessaryDescription:
      'Estes cookies são essenciais para o funcionamento correto do site. Eles permitem funções básicas como navegação de páginas e acesso a áreas seguras do site. O site não pode funcionar corretamente sem estes cookies.',
    analyticsDescription:
      'Estes cookies nos ajudam a entender como os visitantes interagem com nosso site, coletando e reportando informações de forma anônima. Esses dados são usados para melhorar o desempenho e a experiência do usuário em nosso site.',
  },
};
export { ptBR };
